<template>
    <li class="list-group-item" :class="detalle ? 'lightgray2-content' : ''">
        <div class="row">
            <div class="col-12 d-flex justify-content-between" @click="detalle = !detalle">
                <span>
                    <b>{{ pedido.evento.name }}</b>
                    <span v-if="pedido.sesion"> | <b>{{ pedido.sesion.fecha }}</b></span> |
                    <b> {{ $t('perfil.n_pedido') }}: {{ pedido.id }}</b>
                    | <b>{{ $t('perfil.entradas') }}: {{ pedido.units }}</b>
                </span>
                <span>
                    <i :class="detalle ? 'fas fa-chevron-up' : 'fas fa-chevron-down'"></i>
                </span>
            </div>
            <transition name="fade" mode="out-in">
                <div class="col-12" v-if="detalle">
                    <div class="pt-3 row">
                        <div class="mb-4 text-center col-12 d-flex flex-column flex-md-row justify-content-center">
                            <template v-if="pedido.puede_descargar_entradas">
                                <a v-if="!anuladas" class="button" :href="pedido.url_pdf" target="_blank">{{ $t('perfil.descargar_todas') }}</a>
                                <button v-if="!anuladas" @click="enviarEntradas()" class="mt-2 button ml-md-2 mt-md-0">{{ $t('perfil.enviar_entradas') }}</button>
                            </template>
                            <router-link :to="{ name: 'cambiar-datos-entradas', params: { tpv_order: pedido.id } }" v-if="pedido.evento?.solicitar_datos && !sinCosteDeCambio" class="mt-2 button ml-md-2 mt-md-0">
                                {{ $t('perfil.cambiar_datos') }}
                                <InfoToolTip class="mb-1" v-if="pedido.entradas[0]?.fecha_limite_cambiar_datos" :info="$t('perfil.limite_cambiar_datos', { fecha_fin_evento: pedido.entradas[0]?.fecha_limite_cambiar_datos?.nombre })" />
                            </router-link>
                        </div>
                        <div class="col-12">
                            <div class="row pr-md-4 pl-md-4">
                                <template v-for="(entrada, index) in pedido.entradas">
                                    <div class="col-12 d-flex justify-content-between" :key="entrada.id">
                                        <ul class="pb-4 list-group" style="width: 100%">
                                            <li class="list-group-item">{{ $t('perfil.entrada') }} N°: <b>{{++index}}</b></li>
                                            <li v-if="pedido.puede_descargar_entradas" class="list-group-item">{{ $t('perfil.qr_code') }}: <b>{{ entrada.qr_code }}</b></li>
                                            <li class="list-group-item" v-if="pedido.evento?.solicitar_datos">
                                                {{ $t('formularios.dni') }}: <b>{{ entrada.user_dni }}</b>
                                                <CambiarDatos v-if="pedido.evento?.solicitar_datos && entrada.puede_cambiar_datos && !entrada.deleted_at && sinCosteDeCambio" :entrada="entrada" :esMovil="esMovil" :left="'14.8em'" :top="'0.5em'" @close="closeModal" @show="showModal"/>
                                            </li>
                                            <li class="list-group-item" v-if="pedido.evento?.solicitar_datos">
                                                {{ $t('formularios.nombre') }}: <b>{{ entrada.user_nombre }} {{ entrada.user_apellidos }}</b>
                                                <CambiarDatos v-if="pedido.evento?.solicitar_datos && entrada.puede_cambiar_datos && !entrada.deleted_at && sinCosteDeCambio" :entrada="entrada" :esMovil="esMovil" :left="'24.85em'" :top="'0.55em'" @close="closeModal" @show="showModal"/>
                                            </li>
                                            <li class="list-group-item">
                                                <ul class="list-group" style="list-style:none;">
                                                    <li>{{ $t('perfil.enviado') }}: {{ entrada.enviado ? $t('perfil.si_enviado') : $t('perfil.no_enviado') }}</li>
                                                    <li v-if="entrada.enviado && entrada.enviado.email">Email: {{entrada.enviado.email}}</li>
                                                    <li v-if="entrada.enviado && entrada.enviado.telefono">{{ $t('perfil.telefono') }}: {{entrada.enviado.telefono}}</li>
                                                    <li v-if="entrada.enviado">{{ $t('perfil.fecha') }}: {{entrada.enviado.fecha}}</li>
                                                </ul>
                                            </li>
                                            <li class="list-group-item">{{ $t('perfil.ANULADA') }}: {{entrada.deleted_at ? 'SI' : 'NO'}}</li>
                                            <li class="list-group-item" v-if="!entrada.deleted_at && (pedido.date_caducidad || entrada.date_caducidad && entrada.deleted_at)">
                                                <ul class="list-group" style="list-style:none;">
                                                    <li>{{ $t('perfil.caducara') }}: {{!entrada.download_date  ? 'SI' : 'NO'}}</li>
                                                    <li v-if="!entrada.download_date">{{ $t('perfil.fecha') }}: {{pedido.date_caducidad ? pedido.fecha_caducidad : entrada.fecha_caducidad }}</li>
                                                </ul>
                                            </li>
                                            <template v-if="entrada.asiento">
                                                <li class="list-group-item">
                                                    {{ $t('perfil.zona') }}: <b>{{ entrada.asiento.zona }}</b>
                                                </li>
                                                <li class="list-group-item">
                                                    {{ $t('perfil.fila') }}: <b>{{ entrada.asiento.fila }}</b>
                                                </li>
                                                <li class="list-group-item">
                                                    {{ $t('perfil.asiento') }}: <b>{{ entrada.asiento.asiento }}</b>
                                                </li>
                                            </template>
                                            <li class="list-group-item" v-if="entrada.deleted_at == null && teatro?.seguro_entradas_activo">
                                                <template v-if="entrada.seguro_entradas && teatro?.seguro_entradas_activo">
                                                    <i class="fas fa-shield-alt text-success"></i>
                                                    <b class="ml-2 text-success">{{ $t('perfil.entrada_asegurada') }}</b>
                                                    <p class="mb-0 ml-4 text-muted small">
                                                        {{ $t('perfil.entrada_asegurada_descripcion') }}
                                                    </p>
                                                </template>
                                                <template v-else>
                                                    <i class="fas fa-shield-alt text-muted"></i>
                                                    <b class="ml-2 text-muted">{{ $t('perfil.sin_seguro') }}</b>
                                                </template>
                                            </li>
                                            <li class="p-3 list-group-item d-flex justify-content-between" v-if="entrada.deleted_at == null && pedido.puede_descargar_entradas">
                                                <a class="button" :href="entrada.url_pdf" target="_blank">{{ $t('perfil.descargar') }}</a>
                                                <button @click="showModal('send-' + entrada.id)" class="ml-3 button">{{ $t('perfil.enviar_entrada') }}</button>
                                            </li>
                                            <li class="p-3 list-group-item d-flex justify-content-between" v-else>
                                                <h4>Las entradas serán enviadas por correo electrónico 72 horas antes del evento.</h4>
                                            </li>
                                            <SendTicketModal :id="entrada.id" :order_id="pedido.id" :qr_codes="[entrada.qr_code]" :entradas_id="[entrada.id]" @close="closeModal"/>
                                        </ul>
                                    </div>
                                </template>
                            </div>
                        </div>
                        <div v-if="pedido.productos" class="m-auto col-12 col-md-11">
                            <h5 class="mb-3">{{ $t('perfil.productos') }}</h5>
                            <div class="row">
                                <div class="col-12 pr-md-2 pl-md-2" v-for="(producto) in pedido.productos" :key="producto.id">
                                    <div class="mb-3 card">
                                        <div class="card-body d-flex align-items-center">
                                            <img v-if="producto.image" :src="producto.image" alt="Imagen del producto" class="mr-3 img-thumbnail" style="width: 100px; height: auto;"/>
                                            <div>
                                                <h6 class="mb-1 card-title">{{ producto.name }}</h6>
                                                <p class="mb-1">{{ $t('perfil.producto_descripcion') }}: <b>{{ producto.description }}</b></p>
                                                <p class="mb-0">{{ $t('perfil.producto_unidades') }}: <b>{{ producto.units }}</b></p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>
        </div>
    </li>
</template>

<script setup>
    import { ref, computed } from 'vue';
    import SendTicketModal from './SendTicketModal.vue';
    import CambiarDatos from './CambiarDatos.vue';
    import InfoToolTip from '@/components/common/InfoToolTip';
    import { useVersionMovil } from '@/composables/common/useVersionMovil';
    import { getCurrentInstance } from 'vue';
    import store from '@/store';

    const props = defineProps({
        pedido: { type: Object, required: true }
    });

    const emit = defineEmits(['enviar']);
    const instance = getCurrentInstance();
    const $modal = instance.proxy.$modal;
    const { esMovil } = useVersionMovil();

    const teatro = computed(() => store.getters.getTeatro);
    const detalle = ref(false);

    const anuladas = computed(() => {
        const countAnuladas = props.pedido.entradas.filter(entrada => entrada.deleted_at != null).length;
        const countEntradas = props.pedido.entradas.length;
        return countAnuladas === countEntradas;
    });

    const sinCosteDeCambio = computed(() => {
        return props.pedido?.evento?.coste_cambio_nombre === '0.00';
    });

    const enviarEntradas = () => {
        emit('enviar', props.pedido);
    };

    const showModal = modalName => {
        $modal.show(modalName);
    };

    const closeModal = modalName => {
        $modal.hide(modalName);
    };
</script>
